import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { RootState } from '~/xidrApp/store/types'
import { resetRedirect } from '~/xidrApp/store/route/actions'

const RouteHooks: React.FC = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const currentRedirect = useSelector((state: RootState) => state.route.currentRedirect)

  const whenSwitchRoute = useCallback(() => {
    window.scrollTo(0, 0)
    dispatch(resetRedirect())
  }, [dispatch])

  useEffect(() => {
    whenSwitchRoute()
  }, [location, whenSwitchRoute])

  if (currentRedirect === null) {
    return null
  }

  return <Navigate to={currentRedirect} replace />
}

export default RouteHooks
